<template>
  <div class="index">
    <div class="index-con"> 
      <div class="big-title">
		  <span>Call for Papers</span>
	  </div>
      <div class="small-title w-350 font-17">Topics are as follows:</div>

      <div
        class="small-title w-350 font-400"
        v-for="(item, index) in dataList"
        :key="index"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataList: [
        "Fundamentals, modeling, and simulation",
        "Physical properties and product quality",
        "Industrial processes and equipment",
        "Measurement and process control",
        "Energy and environmental issues",
        "Osmotic dehydration and drying",
        "Drying of gases and liquids",
        "Drying of powdered solids",
        "Drying in biomass energy applications",
        "Drying of food and agricultural materials",
        "Drying of biological and pharmaceutical materials",
        "Drying of chemicals and polymers",
        "Drying of wood, pulp and paper, forest products",
        "Novel drying technologies, R&D opportunities",
      ],
      h5show: false,
    };
  },
  methods: {},
};
</script>

<style scoped>
.title {
  color: #0a9a7a;
  font-size: 24px;
  text-align: center;
  line-height: 40px;
  font-weight: 600;
  margin-bottom: 70px;
  margin-top: 50px;
  position: relative;
}

.title::after {
  content: "";
  left: 50%;
  bottom: 0px;
  transform: translateX(-50%);
  width: 180px;
  height: 4px;
  text-align: center;
  background: #0a9a7a;
  position: absolute;
  margin-bottom: -10px;
}

.index-con {
  margin: 0 auto;
  width: 1200px;
  padding-bottom: 70px;
}

.text {
  color: #333;
  text-indent: 2em;
  line-height: 2;
  padding-bottom: 20px;
}
.w-350 {
  padding-left: 420px;
  margin: 0 auto;
  text-indent: 0;
}

.small-title {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 20px;
}
.font-17 {
  font-size: 19px;
}
.font-400 {
  font-weight: 400;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .nav {
    width: 100%;
  }

  .title {
    font-size: 18px;
  }

  .w-350 {
    padding-left: 10px;
  }
  .index {
    padding: 40px 10px 0;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/callPapers.vue